import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function IntroCallout() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3307">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3308">
        <div className="flex items-start gap-4 p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#ffffff',
        borderLeft: '4px solid #c8a84b',
        borderTop: '1px solid #ede9e0',
        borderRight: '1px solid #ede9e0',
        borderBottom: '1px solid #ede9e0'
      }} data-id="element-3309">
          <AlertCircleIcon className="flex-shrink-0 mt-0.5" size={24} style={{
          color: '#1e3d2f'
        }} data-id="element-3310" />
          <p className="text-lg md:text-xl font-medium leading-relaxed" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3311">
            FLSC Sporting Clays Course is open 7 days a week to Red Card
            Holders. Be sure to check the club calendar for any closures.
          </p>
        </div>
      </div>
    </div>;
}